import { useEffect, useRef, useState } from "react";

export const useDebouncedValue = <T>(
  valueToDebounce: T,
  timeout = 500
): [T] => {
  const [v, setV] = useState<T>(valueToDebounce);
  const timeoutFilter = useRef<unknown>();

  useEffect(() => {
    if (timeoutFilter.current) {
      clearTimeout(timeoutFilter.current as number);
    }
    timeoutFilter.current = setTimeout(() => {
      setV(valueToDebounce);
    }, timeout);
  }, [valueToDebounce, timeout]);

  return [v];
};
